
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BusinessDetailsErrorsResource,
  ComplianceScope,
  ComplianceStatus,
  FreelanceCompanyBusinessDetailsResource,
  FreelanceCompanyResource,
  FreelancerCompanyDocumentsResource,
  FreelancerCompanyUpdateBusinessDetailsRequest,
  JoinUmbrellaCompanyErrorResponse,
  JoinUmbrellaCompanyRequest,
  UmbrellaCompanyInvitationRequest,
} from '../models';
import {
    BusinessDetailsErrorsResourceFromJSON,
    BusinessDetailsErrorsResourceToJSON,
    ComplianceScopeFromJSON,
    ComplianceScopeToJSON,
    ComplianceStatusFromJSON,
    ComplianceStatusToJSON,
    FreelanceCompanyBusinessDetailsResourceFromJSON,
    FreelanceCompanyBusinessDetailsResourceToJSON,
    FreelanceCompanyResourceFromJSON,
    FreelanceCompanyResourceToJSON,
    FreelancerCompanyDocumentsResourceFromJSON,
    FreelancerCompanyDocumentsResourceToJSON,
    FreelancerCompanyUpdateBusinessDetailsRequestFromJSON,
    FreelancerCompanyUpdateBusinessDetailsRequestToJSON,
    JoinUmbrellaCompanyErrorResponseFromJSON,
    JoinUmbrellaCompanyErrorResponseToJSON,
    JoinUmbrellaCompanyRequestFromJSON,
    JoinUmbrellaCompanyRequestToJSON,
    UmbrellaCompanyInvitationRequestFromJSON,
    UmbrellaCompanyInvitationRequestToJSON,
} from '../models';

export interface GetBusinessDetailsRequest {
    companyId: string;
}

export interface GetCompanyRequest {
    companyId: string;
}

export interface GetCompanyComplianceStatusRequest {
    freelancerCompanyId: string;
}

export interface GetDocumentsRequest {
    companyId: string;
    complianceScope?: ComplianceScope;
    includeOnlyDocumentsNeedingUpdate?: boolean;
}

export interface InviteUmbrellaCompanyRequest {
    companyId: string;
    umbrellaCompanyInvitationRequest: UmbrellaCompanyInvitationRequest;
}

export interface JoinUmbrellaCompanyOperationRequest {
    companyId: string;
    joinUmbrellaCompanyRequest: JoinUmbrellaCompanyRequest;
}

export interface UpdateBusinessDetailsRequest {
    companyId: string;
    freelancerCompanyUpdateBusinessDetailsRequest: FreelancerCompanyUpdateBusinessDetailsRequest;
}

/**
 * 
 */
export class FreelancerCompanyApi extends runtime.BaseAPI {

    /**
          */
    async getBusinessDetailsRaw(requestParameters: GetBusinessDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelanceCompanyBusinessDetailsResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getBusinessDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelanceCompanyBusinessDetailsResource>({
            path: `/compliance/api/company/{companyId}/business-details`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelanceCompanyBusinessDetailsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getBusinessDetails(requestParameters: GetBusinessDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelanceCompanyBusinessDetailsResource> {
        const response = await this.getBusinessDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getCompanyRaw(requestParameters: GetCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelanceCompanyResource>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelanceCompanyResource>({
            path: `/compliance/api/company/{companyId}`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelanceCompanyResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCompany(requestParameters: GetCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelanceCompanyResource> {
        const response = await this.getCompanyRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getCompanyComplianceStatusRaw(requestParameters: GetCompanyComplianceStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ComplianceStatus>> {
        if (requestParameters['freelancerCompanyId'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyId',
                'Required parameter "freelancerCompanyId" was null or undefined when calling getCompanyComplianceStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ComplianceStatus>({
            path: `/compliance/api/company/{freelancerCompanyId}/compliance/status`.replace(`{${"freelancerCompanyId"}}`, encodeURIComponent(String(requestParameters['freelancerCompanyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ComplianceStatusFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCompanyComplianceStatus(requestParameters: GetCompanyComplianceStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ComplianceStatus> {
        const response = await this.getCompanyComplianceStatusRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getCurrentCompanyRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelanceCompanyResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelanceCompanyResource>({
            path: `/compliance/api/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelanceCompanyResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCurrentCompany(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelanceCompanyResource> {
        const response = await this.getCurrentCompanyRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<FreelancerCompanyDocumentsResource>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['complianceScope'] != null) {
            queryParameters['complianceScope'] = requestParameters['complianceScope'];
        }

        if (requestParameters['includeOnlyDocumentsNeedingUpdate'] != null) {
            queryParameters['includeOnlyDocumentsNeedingUpdate'] = requestParameters['includeOnlyDocumentsNeedingUpdate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<FreelancerCompanyDocumentsResource>>({
            path: `/compliance/api/company/{companyId}/documents`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(FreelancerCompanyDocumentsResourceFromJSON);
        return response;
    }

    /**
          */
    async getDocuments(requestParameters: GetDocumentsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<FreelancerCompanyDocumentsResource>> {
        const response = await this.getDocumentsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async inviteUmbrellaCompanyRaw(requestParameters: InviteUmbrellaCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling inviteUmbrellaCompany().'
            );
        }

        if (requestParameters['umbrellaCompanyInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'umbrellaCompanyInvitationRequest',
                'Required parameter "umbrellaCompanyInvitationRequest" was null or undefined when calling inviteUmbrellaCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/company/{companyId}/umbrella/invite`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UmbrellaCompanyInvitationRequestToJSON(requestParameters['umbrellaCompanyInvitationRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async inviteUmbrellaCompany(requestParameters: InviteUmbrellaCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.inviteUmbrellaCompanyRaw(requestParameters, initOverrides);
    }

    /**
     * Allows a freelancer company to join a specific umbrella company. This endpoint handles the umbrella company joining logic separately from other business details updates. 
     * Join an umbrella company
          */
    async joinUmbrellaCompanyRaw(requestParameters: JoinUmbrellaCompanyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling joinUmbrellaCompany().'
            );
        }

        if (requestParameters['joinUmbrellaCompanyRequest'] == null) {
            throw new runtime.RequiredError(
                'joinUmbrellaCompanyRequest',
                'Required parameter "joinUmbrellaCompanyRequest" was null or undefined when calling joinUmbrellaCompany().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/company/{companyId}/umbrella/join`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JoinUmbrellaCompanyRequestToJSON(requestParameters['joinUmbrellaCompanyRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Allows a freelancer company to join a specific umbrella company. This endpoint handles the umbrella company joining logic separately from other business details updates. 
     * Join an umbrella company
          */
    async joinUmbrellaCompany(requestParameters: JoinUmbrellaCompanyOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.joinUmbrellaCompanyRaw(requestParameters, initOverrides);
    }

    /**
          */
    async updateBusinessDetailsRaw(requestParameters: UpdateBusinessDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling updateBusinessDetails().'
            );
        }

        if (requestParameters['freelancerCompanyUpdateBusinessDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'freelancerCompanyUpdateBusinessDetailsRequest',
                'Required parameter "freelancerCompanyUpdateBusinessDetailsRequest" was null or undefined when calling updateBusinessDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/company/{companyId}/business-details`.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FreelancerCompanyUpdateBusinessDetailsRequestToJSON(requestParameters['freelancerCompanyUpdateBusinessDetailsRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateBusinessDetails(requestParameters: UpdateBusinessDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBusinessDetailsRaw(requestParameters, initOverrides);
    }

}
